<template>
    <div class="wrapper">
        <div class="isDisable"></div>
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <div class="content-header">
                <div class="container-fluid container_step">
                    <div class="alert alert-warning" role="alert">
                        Complete Your Transaction!
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-4">
                                    <figure>
                                        <img :src="fund.image" class="w-100" alt="">
                                    </figure>
                                </div>
                                <div class="col-lg-8">
                                    <h3 class="fw-bold">{{fund.name}}</h3>

                                    <div class="row">
                                        <div class="col-6">
                                            <p class="title">Risk Level</p>
                                            <h5 class="text">
                                                <span v-if="fund.risk_level == 3" class="badge badge-danger">HIGH</span>
                                                <span v-else-if="fund.risk_level == 2" class="badge badge-warning">MEDIUM</span>
                                                <span v-else-if="fund.risk_level == 1" class="badge badge-success">LOW</span>
                                                <span v-else>-</span>
                                            </h5>
                                        </div>
                                        <!-- <div class="col-6">
                                            <p class="title">Trade Report</p>
                                            <p class="text">
                                                <a :href="fund.trade_report_file" target="_blank" rel="noopener noreferrer">
                                                    <svg id="file_download_icon" xmlns="http://www.w3.org/2000/svg" width="13.473" height="16" viewBox="0 0 13.473 16">
                                                        <path id="Icon_material-insert-drive-file" data-name="Icon material-insert-drive-file" d="M7.486,3A1.5,1.5,0,0,0,6.007,4.519L6,16.675a1.5,1.5,0,0,0,1.479,1.519H16.4a1.507,1.507,0,0,0,1.486-1.519V7.558L13.431,3Z" transform="translate(-6 -3)" fill="#1b1b1b" opacity="0.5"/>
                                                        <path id="Path_329" data-name="Path 329" d="M0,0,4.558,4.558H1.013A1.013,1.013,0,0,1,0,3.545Z" transform="translate(7.381 0)" fill="#1b1b1b"/>
                                                        <path id="Icon_awesome-long-arrow-alt-down" data-name="Icon awesome-long-arrow-alt-down" d="M4.647,9.936V6.69a.271.271,0,0,0-.271-.271H3.112a.271.271,0,0,0-.271.271V9.936H1.8a.542.542,0,0,0-.383.925L3.361,12.8a.542.542,0,0,0,.766,0L6.07,10.861a.542.542,0,0,0-.383-.925Z" transform="translate(7.243 3.037)" fill="#1b1b1b"/>
                                                    </svg>
                                                </a>
                                            </p>
                                        </div> -->
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Strategy</p>
                                            <p class="text" v-html="details[0] ? details[0] : '-'">
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Description</p>
                                            <p class="text" v-html="details[1] ? details[1] : '-'">
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Robot Type</p>
                                            <p class="text">
                                                {{details[2] ? details[2] : '-'}}
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Recommended Lot Size</p>
                                            <p>
                                                <span v-for="lot in details[3].split(',')" :key="lot.id" class="badge bg-dark me-1">{{lot ? lot : '-'}}</span>
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Recommended Active Pair</p>
                                            <p class="text">
                                                {{details[4] ? details[4] : '-'}}
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Recommended Pair Option</p>
                                            <p>
                                                <span v-for="pair in details[5].split(',')" :key="pair.id" class="badge bg-dark me-1">{{pair ? pair : '-'}}</span>
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title">
                                                Last updated at : <span class="badge badge-light">{{fund.updated_at | moment}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div class="broker">
                                        <p class="text-muted m-0">Broker :</p>
                                        <img :src="broker.logo" class="broker_img" alt="">
                                        <h5 class="mb-3 fw-bold">{{broker.name}}</h5>

                                        <div class="step">
                                            <div class="row">
                                                <div class="col-12">
                                                    <h5>How To Activate Broker :</h5>
                                                    <div class="timeline">
                                                        <!-- timeline item -->
                                                        <div>
                                                            <div class="bullet bg-red">
                                                            </div>
                                                            <div class="timeline-item">
                                                            <!-- <span class="time"><i class="fas fa-clock"></i> 5 mins ago</span> -->
                                                            <h3 class="timeline-header no-border">Step nomor 1</h3>
                                                            </div>
                                                        </div>
                                                        <!-- END timeline item -->
                                                        <!-- timeline item -->
                                                        <div>
                                                            <div class="bullet bg-red"></div>
                                                            <div class="timeline-item">
                                                            <!-- <span class="time"><i class="fas fa-clock"></i> 5 mins ago</span> -->
                                                            <h3 class="timeline-header no-border">Step nomor 2</h3>
                                                            </div>
                                                        </div>
                                                        <!-- END timeline item -->
                                                        <!-- timeline item -->
                                                        <div>
                                                            <div class="bullet bg-red"></div>
                                                            <div class="timeline-item">
                                                            <!-- <span class="time"><i class="fas fa-clock"></i> 5 mins ago</span> -->
                                                            <h3 class="timeline-header no-border">Step nomor 3</h3>
                                                            </div>
                                                        </div>
                                                        <!-- END timeline item -->
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <blockquote>
                                                <h5>Cara Aktivasi Broker :</h5>
                                                <ol>
                                                    <li>Step nomor 1</li>
                                                    <li>Step nomor 2</li>
                                                    <li>Step nomor 3</li>
                                                </ol>
                                            </blockquote> -->
                                        </div>
                                    </div>

                                    <button type="button" @click="goOut()" class="btn btn_red to_deposit">
                                        Continue to deposit
                                    </button>

                                    <!-- <div class="modal fade" id="chooseBroker" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered">
                                            <div class="modal-content">
                                                <div class="modal-body">
                                                    <div class="text-center">
                                                        <h3 class="title">{{brokerName}}</h3>
                                                        <p>Are you sure to choose this Broker?</p>
                                                    </div>

                                                    <form @submit.prevent="handleProduct()">
                                                        <input type="hidden" v-model="product.investor_id" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.broker_account_id" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.product_id" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.product_type" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.payment_amount" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.currency" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.status" class="form-control" readonly >
                                                        <div class="row">
                                                            <div class="col-lg-6 mx-auto">
                                                                <div class="text-center button d-flex align-items-center justify-content-center">
                                                                    <button type="button" class="btn btn_grey m-2" data-dismiss="modal">No</button>
                                                                    <button type="submit" class="btn btn_red">Yes, I'm sure</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <dash-footer></dash-footer>
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import axios from 'axios'
// import $ from 'jquery'
import moment from "moment";

export default {
    name: "AllRobot",
    components: {
        DashHeader,
        DashFooter,
        Sidebar,
    },
    data(){
        return{
            user_id: localStorage.getItem('user_id'),
            fund: [],
            broker:[],
            details:[],
            brokerName: '',
            transaction: [],
            product: {
                investor_id : '',
                broker_choice : '',
                product_id : '',
                product_type : '',
                payment_amount : '',
                currency : '',
                status : '',
            }
        }
    },
    async mounted(){
        window.scrollTo(0,0)
        
        await axios.get(`investor/fundmanager/${this.$route.params.id}`)
        .then(response => {
            // console.log('Fund Manager All: ', response.data.data)
            this.fund = response.data.data
        }).catch(() => {
            // console.log('Error Fund Manager: ', err.response)
        })
        this.details = this.fund.strategy.split(';');

        await axios.get(`investor/fundmanager/${this.$route.params.id}/brokerchoice`)
        .then(response => {
            var brokers = response.data.data
            // console.log('Broker: ', response.data.data)
            for (let i = 0; i < brokers.length; i++) {
                if (brokers[i].id == this.$route.params.broker_id) {
                    this.broker = brokers[i]
                    // console.log("Broker : ", this.broker)
                }
            }
        }).catch(() => {
            // console.log('Error broker: ', err.response)
        })
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY, h:mm:ss a');
        }
    },
    methods: {
        sendBroker(broker){
            this.brokerName = broker.name
        },
        handleProduct(){
            let data = new FormData()
            data.append('investor_id', this.user_id)
            data.append('broker_choice', this.broker.id)
            data.append('product_id', this.fund.id)
            data.append('product_type', 'FUND_MANAGER')

            // axios.put(`transaction/${localStorage.transaction_id}/`, data)
            axios.put(`investor/transaction/${localStorage.transaction_id}/broker-choice/`, data)
            .then(() => {
                // console.log(response);
                // $('#chooseBroker').modal('hide')
                window.open('https://bithouse.id', '_blank')
                this.$router.push('/subscriptions')
            }).catch(() => {
                // console.log(err.response);
            })
        },
        goOut(){
            window.open('https://bithouse.id', '_blank')
            this.$router.push('/subscriptions')
        }
        // link(){
        //     window.open('https://bithouse.id', '_blank')
        //     this.$router.push('/dash')
        // }
    }
}
</script>

<style>
.isDisable{
    background: rgba(255, 255, 255, 0.1);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 1040;
}
.container_step{
    position: relative;
    z-index: 1041;
}
/* button.to_deposit{
    position: relative;
    z-index: 1041;
} */
.content-wrapper{
    background: transparent !important;
}
.card.available-robot__card{
    border-radius: 25px;
}
.myrobot-card__heading {
    font-weight: bold;
    font-size: 18px;
}
.myrobot-card__text {
    color: rgba(0, 0, 0, 0.6);
    font-weight: bold;
    font-size: 12px;
    /* margin-top: 5px; */
}
.myrobot-card__value {
    font-weight: bold;
    margin-top: -15px;
    font-size: 12px;
}
button.myrobot-card__button {
    border-radius: 25px;
    width: 100%;
    font-weight: 500;
    font-size: 15px;
}
.myrobot-card__images {
    width: 190px;
    height: 178px;
    object-fit: cover;
    margin-bottom: 15px;
}

.broker .broker-list{
    text-decoration: none;
    color: var(--dark-grey);
}
.broker a.broker-list:hover > .broker-body{
    border: 1px solid var(--red);
}
.broker .broker-list .broker-body{
    border: 1px solid rgb(168, 168, 168);
    background: white;
    padding: 10px;
    transition: all 0.3s ease;
}
.broker .broker-list .broker-body figure{
    width: 100%;
    height: 80px;
}
.broker .broker-list .broker-img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>